import { get } from 'lodash';

export default (valuesByKey) => {
  const title = get(valuesByKey, ['Appraisal.Title', 'Value']);
  switch (title) {
    case 'Discussion':
      return 'appraisal.discussion';
    case 'Development':
      return 'appraisal.development';
    case 'Conversation':
      return 'appraisal.conversation';
    default:
      return 'appraisal.title';
  }
};



// WEBPACK FOOTER //
// ./src/containers/utils/getAppraisalTitle.js